import React, { Component } from 'react';
import { mixin, RefluxMixin } from 'Util';
import CourseStore from 'stores/Course';
import CourseActions from 'actions/Course';
import NoteOverview from 'components/Notes/NotesOverview';
import RulerBar from 'components/RulerBar';
import AppPage from 'components/AppPage';

class NotesContainer extends mixin(RefluxMixin, Component) {
  listenToStores() {
    this.listenToStore(CourseStore);
  }

  componentDidMount() {
    CourseActions.findNotes();
  }
  render() {
    return (
      <AppPage header={<RulerBar title="Notes" />}>
        <div style={{ margin: '3em' }}>
        {this.state.notes.map(course => (
          <NoteOverview
            id={course.id}
            course={course}
            notes={course.sections}
            {...this.props}
          />
        ))}
        </div>
      </AppPage>
    );
  }
}

export default NotesContainer;



// WEBPACK FOOTER //
// ./src/js/components/Route/NotesContainer.js